module.exports = __webpack_public_path__ + "img/SES_40_38_037_460.5609a90d.jpg";